export const reportFeaturesItemsLeft = [
    "Данные из ПТС",
    "Страховые выплаты",
    "История пробегов",
    "Данные о техосмотрах",
    "Юридическая чистота",
    "Объявления",
    "Штрафы",
    "Таможня"
];

export const reportFeaturesItemsRight = [
    "Экспертная оценка",
    "Характеристики",
    "Среднее время продажи",
    "Опции по VIN",
    "История эксплуатации",
    "Оценка стоимости",
    "Страховые полисы",
    "Транспортный налог"
];